import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async findOne(id, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`pagos-universidades-reportes/${id}`), opciones);
  },
  async findAllPorSolicitudPagoId(solicitudPagoId, opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIPagos(`pagos-universidades-reportes/solicitudes-pagos/${solicitudPagoId}`),
      opciones,
    );
  },
  async findOneV2(id, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos(`pagos-universidades-reportes/v2/${id}`), opciones);
  },
  async findAllPorSolicitudPagoIdV2(solicitudPagoId, opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIPagos(`pagos-universidades-reportes/v2/solicitudes-pagos/${solicitudPagoId}`),
      opciones,
    );
  },
};
